import styled, { CSSProperties, createGlobalStyle } from 'styled-components';
import { bgColors } from 'backgammon_ui_shared';

export const GlobalStyle = createGlobalStyle`

  #root {
    width: 100%;
    height: 100vh;
  }

  body {
    background: ${bgColors.dark};
  }

  .MuiInput-underline:before, .MuiInput-underline:after, .MuiInput-underline:hover {
    border: 0 !important;
    border-bottom: 0 !important;
  }
  .MuiNativeSelect-icon {
    font-size: 40px !important;
    top: calc(50% - 20px) !important;
    color: #070024 !important;
  }

  // Applying general scrollbar styles to the whole app
  * {
    scrollbar-color: ${bgColors.slate500} ${bgColors.slate800};
  }

  *::-webkit-scrollbar {
    width: 10px;
    background-color: ${bgColors.slate800};
  }

  *::-webkit-scrollbar-track {
    border-radius: 8px;
    background-color: ${bgColors.slate800};
  }

  *::-webkit-scrollbar-thumb {
    border-radius: 8px;
    background-color: ${bgColors.slate500};
  }
`;

const containerStyles: CSSProperties = {
  height: '100vh',
  alignItems: 'center',
  justifyContent: 'center',
  display: 'flex',
  flexDirection: 'column',
};

export const Container = styled.div({
  width: '100vw',
  fontFamily: 'Roboto',
  background: bgColors.dark,
  overflow: 'auto',
  ...containerStyles,
});

export const ScreenContainer = styled.div({
  maxWidth: '1280px',
  width: '100%',
  height: '100vh',
  display: 'flex',
  flexDirection: 'column',
});
